<template>
    <div class="lookupdetail">
        <div class="lookup">
            <div class="lookupHeader">
                <label class="titlelabel bottom10">Seating</label>
                       
            </div>
            <div >
                <div class="entryTextDiv">
                    <label class="entryLabel" for="">Seating Type</label>
                </div>
                <select name="" id="" class='entrySelect' v-model="lookupSeatingTypeId" required @change="lookup">
                    <option v-for="s in seatingTypeList_Any" :key="s.id" :value="s.id" >
                        {{s.name}}
                    </option>
                </select>
            </div>
            <formentrystacked inputtype="Date" label="Start Date" v-model="lookupStartDate"  @change="lookup"/>
            <formentrystacked inputtype="Date" label="End Date" v-model="lookupEndDate"  @change="lookup"/>
            <div class="horizFlex ">
                <input class="entryCheckbox" type="checkbox" v-model="showInactive" @change="lookup">
                <label for="" class="mediumtext">Show Inactive</label>
            </div>
            <div class="leftjustified">
                <updateseating @refresh="Refresh" :isAdd="trueParam" buttonclass="innerbutton" @refreshnew="Refresh"/>
            </div>
            
            <div class="resultsdiv" v-if="seatingResults.length>0">
                <div v-for="result in seatingResults" :key="result.id" :value="result.id" >
                    <lookupresult_nocols :topLeft="result.name" :bottomLeft="recurringstring(result)"   @click="select(result)"
                        :selected="result.id==selectedResultID_seating" :inactive="!result.isActive">
                    
                    </lookupresult_nocols>  
                </div>
            </div>
            <seatingtypeadmin typeName="Seating Type" :typeList="seatingTypeList" @save="saveSeatingType"/>
        </div>
  
        <div v-if="selectedResultID_seating>0 && currentseating!=null" class="pad10">
            <div class="bordered">
                <div class="horizFlexStretch">
                    <div class="horizFlex">
                        <label class="titlelabel bold right10">{{currentseating.name}} </label>
                        <updateseating :inseating="currentseating"  @refresh="Refresh"  />
                        <div class="marginleft">
                            <removeseating :inseating="currentseating"  @refresh="Refresh"  />
                        </div>
                        
                    </div>
                   <div></div>
                </div>
                <div class="splitDiv ">
                    <!-- left col -->
                    <div class="leftjustified vertFlex padright">
                        
                        
                        <div class="dataitem_seating" >
                            <p >Name:</p>
                            <p >{{currentseating.name}}</p>
                        </div>
                        
                        <div class="dataitem_seating"  >
                            <p >Type:</p>
                            <p >{{currentseating.seatingTypeName}} </p>
                        </div>
                        <div class="dataitem_seating"  >
                            <p >Date:</p>
                            <p >{{currentseating.seatingDateTime}} </p>
                        </div>
                        <div class="dataitem_seating"  >
                            <p >Is Active:</p>
                            <p >{{currentseating.isActive}}</p> 
                        </div>
                        <div class="dataitem_seating"  >
                            <p >Is Recurring:</p>
                            <p >{{currentseating.isRecurring}}</p> 
                        </div>
                        <div class="dataitem_seating"  >
                            <p >Seats Available:</p>
                            <p >{{currentseating.seatsAvailable}}</p> 
                        </div>
                        <div class="dataitem_seating"  >
                            <p >Seats Reserved:</p>
                            <p >{{currentseating.seatsReserved}}</p> 
                        </div>
                    </div>

                    <!-- right col -->
                    <div class="leftjustified vertFlex ">
                        
                        

                        

                            
                         



                    </div>
                </div>
                
            </div>

        </div>
        
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import datamethods from '../../services/datamethods.js'
  import format from '../../format.js'
  import smallbutton from '../controls/button.vue'
  import lookupresult_nocols from '../controls/lookupresult_nocols.vue'
  import linkbutton from '../controls/linkbutton'
  import updateseating from './updateseating.vue'
  import removeseating from './removeseating.vue'
  import formentrystacked from '../controls/entry-stacked.vue'
  import seatingtypeadmin from '../controls/seatingtypeadmin.vue'
  export default {
      name:'reservationadmin',
      mixins:[datamethods, format],
      components:{
          smallbutton,
          linkbutton,
          updateseating,
          removeseating,
          lookupresult_nocols,
          formentrystacked,
          seatingtypeadmin

      },
      computed:{
          ...mapFields([
            'pleaseWait',
            'pleaseWaitText',
            'seatingTypeList',
            'seatingTypeList_Any',
            'loggedInUser',
            'seatingResults',
            'selectedResultID_seating',
            'currentseating',
          ]),

        

      },
    mounted(){
    
    },
    data(){
          return{
        
            responseMessage:'',
            trueParam:true,
            falseParam:false,
            showInactive:false,
            lookupSeatingTypeId:-1,
            lookupStartDate:null,
            lookupEndDate:null

          }
    },
    methods:{
        async saveSeatingType(thistype){
        
            let req = {
                seatingType:thistype,
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateseatingtype')
            if(response.Successful){
                this.getSeatingTypes() //refresh      
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        dayofweek(result){
            var dow = this.$options.filters.dayOfWeek(result.seatingDateTime)
           // console.log('dow ' + dow)
            return dow
        },
        recurringstring(result){
            if(result.isRecurring){return "*recurring"}
            else{return null}
        },
      select(result){
        console.log('sel')
              this.selectedResultID_seating=result.id
              this.getItem(result.id)
          },
          async Refresh(id){
              console.log('refresh ' + id)
              if(id==undefined){
                if(this.currentseating!=null){id=this.currentseating.id}
              }
              await this.lookup();
              if (this.selectedResultID_seating!=id){
                this.selectedResultID_seating=id
                
              }
              this.getItem(id)
          },
          RefreshCurrent(){
              this.Refresh(this.currentseating.id)
          },
          
          async lookup(){
            this.responseMessage=null

            this.seatingResults=[]
            let req = {

                includeInactive:this.showInactive,
                seatingTypeId:this.lookupSeatingTypeId,
                seatingDate:this.lookupStartDate,
                seatingDate_end:this.lookupEndDate
            }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'seatinglist')
                //handle response
            
                if(response.Successful){
                    this.seatingResults=response.SeatingList
                    if(this.seatingResults.length==0){
                        this.responseMessage="No seatings Found"
                    }
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;   
             
          },
          
          async getItem(id){
            console.log('getitem ' + id)

            this.message = ''
            let req = {
                seatingId:id
            }
            var response = await this.callAPI(req,'seating')    
            if(response.Successful){
                this.currentseating=response.Seating
            }else{
                this.message = response.Message
            }



           /*  var sel
            this.seatingResults.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.id==id){   
                        sel=t
                    } 
                }
            this.currentseating=sel */
            if(this.currentseating!=undefined){
                this.currentseating.seatingDateTime = this.$options.filters.formatDate(this.currentseating.seatingDateTime)
            }
            
  
          },
          async getSeatingTypes(){
                this.message = ''
                var response = await this.callAPI(null,'seatingtypes')    
                if(response.Successful){
                    this.seatingTypeList=response.SeatingTypeList

                    var all = {id:-1,name: 'Any Seating'}
                    this.seatingTypeList_Any = JSON.parse(JSON.stringify(this.seatingTypeList))
                    this.seatingTypeList_Any.push(all)
                }else{
                    this.message = response.Message
                }
            }
          
       
    },
    mounted(){
        this.lookupStartDate=this.$options.filters.formatDateForInputToday()
        let today =new Date();
        var dateend =new Date().setDate(today.getDate()+14);
        this.lookupEndDate=this.$options.filters.formatDateForInput(dateend)
        this.getSeatingTypes()
        this.lookup()
     
      },
  }
  </script>
  
  <style>
 .dataitem_seating{
    display:grid;
    grid-template-columns: 100px auto;
    margin:0px;
    padding:0px;
}
.marginleft{
    margin-left:10px;
}
  </style>